import { render, staticRenderFns } from "./CommissionLog.vue?vue&type=template&id=9209527c&scoped=true&"
import script from "./CommissionLog.vue?vue&type=script&lang=ts&"
export * from "./CommissionLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9209527c",
  null
  
)

export default component.exports